<template>
    <div>
        <div
            ref="deliveryUnitDistribution"
            style="width: 100%; height: 600px"
        ></div>
    </div>
</template>
<script>
/* Imports */
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

export default {
    data() {
        return {
            chart: null,
            plantList: [],
        };
    },
    props: ["data"],
    mounted() {
        this.plantList = this.$store.getters.getPlant.map((x) => x.plant_name);
        this.createChart();
    },
    watch: {
        data: {
            deep: true,
            handler: "getData",
        },
    },
    methods: {
        getData() {
            if (!this.chart) return; // Return if chart is not yet initialized
            let length = this.chart.data.length;
            let data;

            if (this.data && this.data.length > 0) {
                data = this.data;
            } else {
                const result = { tanggal: "No Data" };
                this.plantList.forEach((plant) => {
                    result[plant] = 0;
                });
                data = [result];
            }

            // Add total values to the data
            data.forEach((item) => {
                item.total = this.plantList.reduce(
                    (sum, plant) => sum + (item[plant] || 0),
                    0
                );
            });

            this.chart.addData(data, length);
        },
        createChart() {
            try {
                /* Chart code */
                // Themes begin
                am4core.useTheme(am4themes_animated);
                // Themes end

                // Create chart instance for "delivery_unit"
                this.chart = am4core.create(
                    this.$refs.deliveryUnitDistribution,
                    am4charts.XYChart
                );

                // Create category axis
                let categoryAxis = this.chart.xAxes.push(
                    new am4charts.CategoryAxis()
                );
                categoryAxis.dataFields.category = "tanggal";
                categoryAxis.renderer.grid.template.location = 0;
                categoryAxis.renderer.cellStartLocation = 0.1;
                categoryAxis.renderer.cellEndLocation = 0.9;

                // Create value axis for alokasi series
                let alokasiValueAxis = this.chart.yAxes.push(
                    new am4charts.ValueAxis()
                );
                alokasiValueAxis.min = 0;
                alokasiValueAxis.extraMax = 0.1;

                // Create value axis for delivery series and place it on the right
                let deliveryValueAxis = this.chart.yAxes.push(
                    new am4charts.ValueAxis()
                );
                deliveryValueAxis.min = 0;
                deliveryValueAxis.extraMax = 0.1;
                deliveryValueAxis.renderer.opposite = true;

                // Define colors for each series
                const colors = [
                    "#A7AC1B",
                    "#D9C168",
                    "#7AAF4B",
                    "#4BAFA9",
                    "#909CD0",
                    "#C577B4",
                    "#DE7C7C",
                ]; // Add more colors if needed

                // Create series for plant_alokasi
                for (let i = 0; i < this.plantList.length; i++) {
                    this.createAlokasisSeries(
                        `plant_alokasi_${this.plantList[i]}`, // Use a different field name for plant_alokasi
                        this.plantList[i],
                        colors[i % colors.length]
                    );
                }

                // Create series for delivery_unit
                for (let i = 0; i < this.plantList.length; i++) {
                    this.createSeries(
                        this.plantList[i],
                        this.plantList[i],
                        colors[(i + this.plantList.length) % colors.length]
                    );
                }

                // Add total labels
                this.addTotalLabels();

                // Legend
                let deliveryLegend = this.chart.createChild(am4charts.Legend);
                deliveryLegend.position = "top";
                deliveryLegend.contentAlign = "center";
                deliveryLegend.valign = "center";
                deliveryLegend.fontSize = 12;
                deliveryLegend.maxWidth = 200;
                deliveryLegend.maxHeight = 100;
                deliveryLegend.markers.template.width = 16;
                deliveryLegend.markers.template.height = 16;

                let alokasiLegend = this.chart.createChild(am4charts.Legend);
                alokasiLegend.position = "top";
                alokasiLegend.contentAlign = "center";
                alokasiLegend.valign = "center";
                alokasiLegend.fontSize = 12;
                alokasiLegend.maxWidth = 200;
                alokasiLegend.maxHeight = 100;
                alokasiLegend.markers.template.width = 16;
                alokasiLegend.markers.template.height = 16;

                // Add legends
                this.chart.legend = new am4charts.Legend();
                this.chart.legend.labels.template.fontSize = 15;
                this.chart.legend.itemContainers.template.padding = 5;
                this.chart.legend.useDefaultMarker = true;
                this.chart.legend.position = "top";
                this.chart.legend.contentAlign = "right";
                this.chart.legend.valign = "right";
                this.chart.legend.scrollable = true;

                // Customize legend labels
                this.chart.legend.labels.template.text =
                    "[font-size: 15px]{name}";
                this.chart.legend.data = [
                    { name: "Total Plant", fill: am4core.color("#2830fc") },
                    {
                        name: "Total Delivery",
                        fill: am4core.color("#4d4d4d"),
                    },
                ];
                let marker =
                    this.chart.legend.markers.template.children.getIndex(0);

                marker.cornerRadius(0, 0, 0, 0);
                marker.strokeWidth = 0;

                // Separate series into different legends
                deliveryLegend.data = this.chart.series.values.filter(
                    (series) => series.customType === "delivery"
                );
                alokasiLegend.data = this.chart.series.values.filter(
                    (series) => series.customType === "alokasi"
                );

                // Add cursor
                this.chart.cursor = new am4charts.XYCursor();

                // Add horizontal scrollbar below the chart
                let scrollbarX = new am4core.Scrollbar();
                this.chart.scrollbarX = scrollbarX;
                this.chart.scrollbarX.parent = this.chart.bottomAxesContainer;
                this.chart.scrollbarX.startGrip.hide();
                this.chart.scrollbarX.endGrip.hide();

                // Set chart padding to ensure scrollbar is visible
                this.chart.paddingBottom = 50;

                // Apply pre-zoom after chart is loaded
                this.chart.events.on("datavalidated", () => {
                    categoryAxis.start = 0;
                    categoryAxis.end = 0.3;
                    categoryAxis.keepSelection = true;
                });

                // Disable zoom out button
                this.chart.zoomOutButton.disabled = true;
                this.chart.zoomIn.disabled = true;
            } catch (error) {
                console.error("Error occurred while creating chart:", error);
            }
        },
        createSeries(field, name, color) {
            let series = this.chart.series.push(new am4charts.ColumnSeries());
            series.name = name;
            series.dataFields.valueY = field;
            series.dataFields.categoryX = "tanggal";
            series.sequencedInterpolation = true;

            // Use the right value axis for delivery series
            series.yAxis = this.chart.yAxes.getIndex(1);

            // Remove the stacked property
            series.stacked = true;

            // Add a custom property to identify this series type
            series.customType = "delivery";

            // Set custom color
            series.columns.template.stroke = am4core.color(color);
            series.columns.template.fill = am4core.color(color);

            // Configure columns
            series.columns.template.width = am4core.percent(60); // Adjust width as needed
            series.columns.template.column.cornerRadiusTopLeft = 2;
            series.columns.template.column.cornerRadiusTopRight = 2;
            series.columns.template.column.cornerRadiusBottomLeft = 2;
            series.columns.template.column.cornerRadiusBottomRight = 2;

            // Add label inside each column
            let labelBullet = series.bullets.push(new am4charts.LabelBullet());
            labelBullet.label.text = "{valueY}";
            labelBullet.locationY = 0.5;
            labelBullet.label.fill = am4core.color("#ffffff"); // White font color for visibility inside the bar
            labelBullet.label.hideOversized = true;

            // Add tooltip
            series.tooltipText = "{categoryX}: {valueY}";

            // Add hover state to show tooltip only for thin columns
            let hoverState = series.columns.template.states.create("hover");
            hoverState.properties.fillOpacity = 1;

            // Hide tooltip for columns that are not thin
            hoverState.properties.tooltipText =
                series.columns.template.pixelWidth < 30
                    ? "{categoryX}: {valueY}"
                    : "";

            return series;
        },
        createAlokasisSeries(field, name, color) {
            let series = this.chart.series.push(new am4charts.ColumnSeries());
            series.name = `Alokasi ${name}`;
            series.dataFields.valueY = field;
            series.dataFields.categoryX = "tanggal";
            series.yAxis = this.chart.yAxes.getIndex(0); // Use the first (left) value axis
            series.sequencedInterpolation = true;

            // Remove the stacked property
            series.stacked = true;

            // Add a custom property to identify this series type
            series.customType = "alokasi";

            // Set custom color
            series.columns.template.stroke = am4core.color(color);
            series.columns.template.fill = am4core.color(color);

            // Configure columns
            series.columns.template.width = am4core.percent(60); // Reduce width to 30%
            series.columns.template.column.cornerRadiusTopLeft = 2;
            series.columns.template.column.cornerRadiusTopRight = 2;
            series.columns.template.column.cornerRadiusBottomLeft = 2;
            series.columns.template.column.cornerRadiusBottomRight = 2;

            // Add label inside each column
            let labelBullet = series.bullets.push(new am4charts.LabelBullet());
            labelBullet.label.text = "{valueY}";
            labelBullet.locationY = 0.5;
            labelBullet.label.fill = am4core.color("#ffffff");
            labelBullet.label.hideOversized = true;

            // Add tooltip
            series.tooltipText = "{categoryX}: {valueY}";

            // Add hover state
            let hoverState = series.columns.template.states.create("hover");
            hoverState.properties.fillOpacity = 1;
            hoverState.properties.tooltipText = "{categoryX}: {valueY}";

            // Hide tooltip for columns that are not thin
            hoverState.properties.tooltipText =
                series.columns.template.pixelWidth < 30
                    ? "{categoryX}: {valueY}"
                    : "";

            return series;
        },
        addTotalLabels() {
            this.chart.events.on("datavalidated", () => {
                let deliveryTotal = 0;
                let alokasiTotal = 0;

                this.chart.series.each((series) => {
                    if (
                        series.name ===
                        this.plantList[this.plantList.length - 1]
                    ) {
                        // For delivery columns
                        series.columns.each((column) => {
                            if (column.dataItem) {
                                deliveryTotal =
                                    column.dataItem.dataContext.total;
                                if (deliveryTotal) {
                                    let totalLabel = column.createChild(
                                        am4core.Label
                                    );
                                    totalLabel.text =
                                        "\u25A0 " + deliveryTotal.toString();
                                    totalLabel.fontSize = 14;
                                    totalLabel.align = "center";
                                    totalLabel.dy = -14;
                                    totalLabel.fill = am4core.color("#4d4d4d"); // Black font color for visibility
                                    totalLabel.stroke =
                                        am4core.color("#4d4d4d"); // Stroke color
                                }
                            }
                        });
                    }

                    if (
                        series.name ===
                        `Alokasi ${this.plantList[this.plantList.length - 1]}`
                    ) {
                        // For plant_alokasi columns
                        series.columns.each((column) => {
                            if (column.dataItem) {
                                // Calculate total for plant_alokasi
                                alokasiTotal = this.plantList.reduce(
                                    (sum, plant) => {
                                        return (
                                            sum +
                                            (column.dataItem.dataContext[
                                                `plant_alokasi_${plant}`
                                            ] || 0)
                                        );
                                    },
                                    0
                                );

                                if (alokasiTotal) {
                                    let alokasiTotalLabel = column.createChild(
                                        am4core.Label
                                    );
                                    alokasiTotalLabel.text =
                                        "\u25A0 " + alokasiTotal.toString();
                                    alokasiTotalLabel.fontSize = 14;
                                    alokasiTotalLabel.align = "center";
                                    alokasiTotalLabel.dy = -14;
                                    // alokasiTotalLabel.dx = 30;
                                    alokasiTotalLabel.fill =
                                        am4core.color("#2830fc"); // Black font color for visibility
                                    alokasiTotalLabel.stroke =
                                        am4core.color("#2830fc"); // Stroke color
                                }
                            }
                        });
                    }
                });
            });
        },
    },
};
</script>
<style scoped></style>
